const html = require('choo/html')

module.exports = function Toolbar (args) {
  let {
    categoryA,
    categoryB,
    categoryC,
    categoryCHidden = false,
    id = null
  } = args

  let separatorB = null
  let separatorC = null

  if (categoryA.length > 0) {
    separatorB = html`<hr>`
  }
  if (categoryB.length > 0) {
    separatorC = html`<hr>`
  }

  let hiddenClass = ''
  if (categoryCHidden && categoryA.length === 0 && categoryB.length === 0) {
    hiddenClass = 'hidden'
  }
  if (categoryCHidden){
    categoryC = null
    separatorC = null
    if (categoryB.length === 0){
      separatorB = null
    }
  } 
  return html`
    <div class="toolbar ${hiddenClass}" id=${id}>
      ${categoryA}
      ${separatorB}
      ${categoryB}
      ${separatorC}
      ${categoryC}
    </div>
  `
}
